"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  updateTenantNotificationPolicyAction,
  type TenantNotificationView,
} from "@/server-actions/tenant-notification-policies"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { tenantNotificationPoliciesQueryKey } from "@/hooks/queries/tenant-notification-policies"
import { useTranslations } from "next-intl"


export function useUpdateTenantNotificationPolicyMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsTenantNotificationPolicies")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: {
      eventType: string
      enabled: boolean
      parameters: Record<string, number>
    }): Promise<TenantNotificationView> => {
      const result = await withQueryHandling(updateTenantNotificationPolicyAction(input), {
        loading: tUi("saving"),
        success: tUi("tenantNotificationSaved"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: (saved) => {
      // Patch only the saved card, so the other cards keep their pending edits.
      queryClient.setQueryData<TenantNotificationView[]>(tenantNotificationPoliciesQueryKey, (current) =>
        current?.map((view) => (view.eventType === saved.eventType ? saved : view)),
      )
    },
  })
}
